import momentTimezone from 'moment-timezone';
export const formatStringDatetimeRequest = (startTime: string) => {
  return Number(momentTimezone.tz(startTime as string,"YYYY/MM/DD HH:mm:ss", "America/Danmarkshavn").unix())
}